type MeetingAttendeesInput = {
  applicantIds: number[]
  contactIds: number[]
  participants: string[]
  locationContactId?: number
}

type MeetingAttendees = {
  applicants: number[]
  contacts: number[]
  participants: string[]
}

export const meetingAttendees = ({
  applicantIds,
  contactIds,
  participants,
  locationContactId
}: MeetingAttendeesInput): MeetingAttendees => {
  if (applicantIds.length > 0) {
    return {
      applicants: applicantIds,
      contacts: locationContactId ? [locationContactId] : [],
      participants
    }
  }

  const locationContactIri = `/v1/contacts/${locationContactId}`
  const invitesLocationContact =
    locationContactId !== undefined &&
    !contactIds.includes(locationContactId) &&
    !participants.includes(locationContactIri)

  return {
    applicants: [],
    contacts: contactIds,
    participants: invitesLocationContact
      ? [...participants, locationContactIri]
      : participants
  }
}
